import { Link } from "@tanstack/react-router";
import { ArrowUpRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { path } from "@/lib/site";
import type { Lang } from "@/i18n";
import { Reveal } from "./Reveal";

type PageKey = "services" | "references" | "about" | "faq" | "tools" | "contact";

export function RelatedLinks({
  lang,
  items,
}: {
  lang: Lang;
  items: PageKey[];
}) {
  const { t } = useTranslation();
  return (
    <section className="section border-t border-[var(--border-strong)]">
      <div className="container-page">
        <Reveal>
          <span className="eyebrow">— {t("related.eyebrow")}</span>
          <h2 className="font-display mt-3 text-2xl font-bold tracking-[-0.02em] md:text-3xl">
            {t("related.title")}
          </h2>
        </Reveal>
        <ul className="mt-10 grid gap-px overflow-hidden border border-[var(--border-strong)] bg-[var(--border)] md:grid-cols-3">
          {items.map((key, i) => (
            <Reveal key={key} delay={i * 0.05}>
              <li className="h-full bg-background">
                <Link
                  to={path(lang, key)}
                  className="group flex h-full flex-col gap-3 p-7 transition-colors hover:bg-[var(--surface)]"
                >
                  <span className="font-mono text-[11px] font-semibold uppercase tracking-[0.14em] text-foreground/55">
                    {t(`nav.${key}`)}
                  </span>
                  <h3 className="font-display text-lg font-semibold leading-tight tracking-[-0.01em]">
                    {t(`related.cards.${key}.title`)}
                  </h3>
                  <p className="text-sm text-foreground/70">
                    {t(`related.cards.${key}.desc`)}
                  </p>
                  <span className="font-display mt-auto inline-flex items-center gap-1.5 pt-4 text-xs font-medium uppercase tracking-[0.12em] text-foreground group-hover:gap-2.5 transition-all">
                    {t("related.cta")} <ArrowUpRight size={14} />
                  </span>
                </Link>
              </li>
            </Reveal>
          ))}
        </ul>
      </div>
    </section>
  );
}